<tcm-main-frame titleKey="Screens.Patients.InfoWidget.SendEmail.Title">
    <ng-container commands>
        <button class="btn btn-complete me-2" (click)="sendEmail()" [disabled]="!templateId || isLoading">
            {{'Screens.Patients.InfoWidget.SendEmail.Actions.SendEmail' | translate}}
        </button>
        <button class="btn btn-default me-4" (click)="back()">
            {{'Common.SearchActionsAndDetailsActions.Cancel' | translate}}
        </button>
    </ng-container>
    <ng-container body>
        <tcm-details-layout>
            <div form-area>
                <form #detailsForm="ngForm">
                    <div class="tcm-details-panel">
                        <div class="row">
                            <div class="col">
                                <waf-select-input #emailTemplateInfo
                                                  name="emailTemplate"
                                                  [label]="'Common.SearchColumnsAndDetailsFields.Template' | translate"
                                                  [(ngModel)]="templateId"
                                                  (ngModelChange)="onEmailTemplateChanged(emailTemplateInfo.selectedOptions)"
                                                  [options]="emailTemplates"
                                                  required="true"></waf-select-input>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div>{{'Screens.Patients.InfoWidget.SendEmail.Fields.Subject' | translate}}:</div>
                                <div class="email-section">{{subject}}</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div>{{'Screens.Patients.InfoWidget.SendEmail.Fields.Body' | translate}}:</div>
                                <div class="email-section body" [innerHTML]="body"></div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </tcm-details-layout>
    </ng-container>
</tcm-main-frame>